import React from "react";
import marquee1 from "../images/brand-1.svg";
import marquee2 from "../images/brand-2.svg";
import marquee3 from "../images/brand-3.svg";
import marquee4 from "../images/brand-4.svg";
import marquee5 from "../images/brand-5.svg";
import marquee7 from "../images/brand-7.svg";
import Marquee from "react-fast-marquee";

const Marque = ({ className, iconList, title }) => {
  const defaultData = [
    {
      image: marquee1,
    },
    {
      image: marquee2,
    },
    {
      image: marquee3,
    },
    {
      image: marquee4,
    },
    {
      image: marquee5,
    },
    // {
    //   image: marquee6,
    // },
    {
      image: marquee7,
    },
    {
      image: marquee1,
    },
    {
      image: marquee2,
    },
    {
      image: marquee3,
    },
    {
      image: marquee4,
    },
    {
      image: marquee5,
    },
    // {
    //   image: marquee6,
    // },
    {
      image: marquee7,
    }
  ];
  const data = iconList ?? defaultData;
  return (
    <div className={`${className}`}>
      {title ? (
        <p className="text-[#141619] text-[20px] sm:text-[24px] font-[600] text-center mx-[16px] mb-[16px] sm:mb-[30px] NunitoSans">
          {title}
        </p>
      ) : null}
      <Marquee>
        {data.map((item, i) => {
          return (
            <img draggable="false"
              key={i}
              src={item.image}
              className="w-full object-contain  h-[60px] sm:h-[80px] m-[10px] mx-[10px] sm:mx-[20px] rounded-[6px] px-1 sm:px-3 aspect-video"
              alt="Arrow_up_small"
            />
          );
        })}
      </Marquee>
    </div>
  );
};

export default Marque;
